// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once visual-form editing renders through an sp app.
import { disableFormBuilderInputs } from "#/shared/legacy/forms/form-preview.js";
import { previewSelectItems } from "./preview-select-items.js";

/** Decorates a page-builder form component with a copied, grouped preview context. */
export function decorateFormComponent(component, copyContext) {
  const renderComponent = component.render.bind(component);

  function renderForm() {
    const context = copyContext(component.context);
    const groups = [];

    if (context.form_template) {
      const fixedChoiceOptions = window.FORM_TEMPLATES?.fixedChoiceOptions;
      const fields = context.form_template.fields ?? [];
      context.form_template.fields = fields.map((field) => previewSelectItems(field, fixedChoiceOptions));

      context.form_template.fields.forEach(function groupField(field) {
        if (field.type === "group_break") {
          groups.push({ label: field.label, template_option: field.template_option, fields: [] });
        } else if (groups.length === 0) {
          groups.push({ fields: [field] });
        } else {
          groups.at(-1).fields.push(field);
        }
      });
      context.form_template.groups = groups;
    }

    context.form = window.Sparkle.HandlebarsTemplates.component_form({ ...context.form_template, ...context });
    renderComponent(context);
    disableFormBuilderInputs(component.element);
  }

  component.render = renderForm;

  return component;
}
